// @ts-ignore
import FormSelect from '@/components/form/FormSelect.vue';
import {isComponentName} from '@/library/utils';
import {type Directive, type DirectiveBinding, type VNode} from 'vue';

const search: Directive = {
    mounted(el: HTMLElement, bindings: DirectiveBinding, vNode: VNode)
    {
        window.setTimeout(() =>
        {
            const modelExpression = bindings.value;
            const preInit         = bindings.modifiers['pre-init'];

            if (!modelExpression)
            {
                console.error('v-search requires a model expression');

                return;
            }

            // form-select
            if (!isComponentName(vNode?.el?.__vue__, 'FormSelect'))
            {
                console.error('v-search is useless, if not bind on a form-select');

                return;
            }

            const instance: FormSelect = vNode.el!.__vue__;
            if (typeof instance?.overwriteDefault !== 'function') {
                console.error('FormSelect.overwriteDefault() not available');

                return;
            }

            instance.overwriteDefault(modelExpression, preInit, vNode.el);
        }, 0);
    },
};

export default search;